const BACKEND_BASE_URL =
  import.meta.env.VITE_API_URL ||
  import.meta.env.VITE_BACKEND_BASE_URL ||
  'http://localhost:3001'

export function getImageUrl(path?: string | null, fallback = ''): string {
  if (!path) return fallback
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('data:') ||
    path.startsWith('blob:')
  ) {
    return path
  }

  // Strip leading /src/ if present
  const cleanPath = (path.startsWith('/') ? path : `/${path}`).replace(
    /^\/src\//,
    '/',
  )

  // If path is a frontend public static asset (e.g. /assets/avatars/...), return direct path
  if (cleanPath.startsWith('/assets/')) {
    return cleanPath
  }

  // Backend uploads (/uploads/...) -> prepend backend origin
  const origin = BACKEND_BASE_URL.replace(/\/api\/?$/, '').replace(/\/+$/, '')
  return `${origin}${cleanPath}`
}
